import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingWrapper from 'components/Common/LoadingWrapper';

const ValidationResultsStacked = ({ result, dirty, isGettingForm, previewOnlyMode }) => {
  function title() {
    if (result != null) {
      if (result.valid) {
        if (!dirty) {
          return <div>
            <span className="text-bold">Results</span>
            <span className="title-rejections_stacked valid">
              <span className="check fa-layers fa-2x">
                <FontAwesomeIcon icon="circle" />
                <span className="fa-sm"><FontAwesomeIcon icon="check" className="layered-button fa-sm" /></span>
              </span>
              { result.rejections != null && result.rejections.length } <FormattedHTMLMessage id="validationResult.rejectionsHint" />
            </span>
          </div>;
        }
        return <div>
          <span className="text-bold">Results</span>
          <div className="title-rejections_stacked invalid">
            <span className="cross fa-layers fa-2x">
              <FontAwesomeIcon icon="circle" />
              <span className="fa-sm"><FontAwesomeIcon icon="times" className="layered-button fa-sm" /></span>
            </span>
            Press &apos;Check&apos;
          </div>
        </div>;
      }
      return <div>
        <span className="text-bold">Results</span>
        <span className="title-rejections_stacked invalid">
          <span className="cross fa-layers fa-2x">
            <FontAwesomeIcon icon="circle" />
            <span className="fa-sm"><FontAwesomeIcon icon="times" className="layered-button fa-sm" /></span>
          </span>
          { result.rejections != null && result.rejections.length } { `Problem${ result.rejections.length !== 1 ? 's' : '' }` }
        </span>
      </div>;
    }
    return <div><span className="text-bold">Results</span></div>;
  }

  return <div id="validation-results-stacked" className="validation-results-stacked">
    <div className="wrapper_box">
      { isGettingForm && <div className="loading-container"><LoadingWrapper text="Please Wait..." /></div> }
      <div>{title()}
        <hr />
        <React.Fragment>
          <div>
            { !result && !isGettingForm && <React.Fragment>
              <p className="cp-primary mt-5"><FormattedHTMLMessage id="stackedFormView.initial.validationHeader" /></p>
              <FormattedHTMLMessage id={ previewOnlyMode ? 'stackedFormView.initial.validationTextPreviewModeOnly' : 'stackedFormView.initial.validationTextDefault' } />
              </React.Fragment>}
          </div>
          <div className="rejections-list">
            { result && result.rejections && result.rejections.length === 0 && dirty && <p>There have been changes made to the form, please press &apos;Check&apos; again to see if there are any more changes needed.</p>}
            { result && result.rejections && result.rejections.length > 0 && <React.Fragment>
              <h3 className="cs-error"><FormattedHTMLMessage id="validationResult.rejectionsTitle" /></h3>
              <ul>
                { result.rejections.map(item => <li key={ item.code }>{item.codeDescription}</li>) }
              </ul>
            </React.Fragment> }
          </div>
          <div className="warnings-list">
            { result && result.warnings && result.warnings.filter(item => item.code.substring(0, 3) === 'WRN').length > 0 && <React.Fragment>
              <h3 className="cp-primary"><FormattedHTMLMessage id="validationResult.warningsTitle" /></h3>
              <ul>
                { result.warnings.map(item => item.code.substring(0, 3) === 'WRN'
                && <li key={ item.code }>{item.codeDescription}</li>) }
              </ul>
            </React.Fragment> }
          </div>
          { result && result.warnings && result.warnings.filter(item => item.code.substring(0, 3) === 'REC').length > 0 && <div>
            <div className="recommendations-list">
              <h3 className="cp-main"><FormattedHTMLMessage id="validationResult.recommendationsTitle" /></h3>
              <ul>
                { result.warnings.map(item => item.code.substring(0, 3) === 'REC'
                && <li key={ item.code }>{item.codeDescription}</li>) }
              </ul>
            </div>
            </div> }
        </React.Fragment>
      </div>
    </div>
  </div>;
};

ValidationResultsStacked.propTypes = {
  result: PropTypes.shape({
    valid: PropTypes.bool,
    formType: PropTypes.string,
    rejections: PropTypes.arrayOf(PropTypes.shape()),
    warnings: PropTypes.arrayOf(PropTypes.shape())
  }),
  dirty: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isGettingForm: PropTypes.bool.isRequired,
  previewOnlyMode: PropTypes.bool.isRequired
};

ValidationResultsStacked.defaultProps = {
  result: null,
  dirty: false
};

export default injectIntl(ValidationResultsStacked);
